import { Checkbox, Grid, Typography, Chip, CircularProgress, Tooltip } from '@mui/material';
import React from 'react';
import InputFields from 'routes/Pages/components/InputFields/InputFields';

import UploadFiles from './UploadFiles';
import { DropzoneUpload } from './InputsRendered';
import { Box } from '@material-ui/core';
import { EmployeeNameField } from 'routes/Pages/GenTask/components/SharedFormFields';

const HfOtherForm = ({ data, setData, files, isLoading, handleFileChange, handleDeleteFiles, viewFile }) => {
  console.log('DATA ====', data);

  const handleChangeData = (name, value) => {
    let updatedData = {
      [name]: value,
    };
    if (name == 'missingHours') {
      updatedData = {
        [name]: value ? 1 : 0,
        nonProductiveHours: !value ? 0 : data['nonProductiveHours'],
      };
    }

    setData(prevData => ({
      ...prevData,
      ...updatedData,
    }));
  };

  return (
    <Grid
      container
      spacing={1}
      sx={{
        '& .MuiTableCell-root': {
          fontSize: '0.825rem',
        },
        '& .MuiInputBase-root': {
          fontSize: '0.825rem !important',
        },
        paddingBottom: '1rem',
      }}>
      <EmployeeNameField value={data['employeeName']} onChange={handleChangeData} isOperator={true} />
      <InputFields
        label="Date & Time"
        name="date_Time"
        required={true}
        value={data['date_Time']}
        textFieldType={'datetime-local'}
        width={2}
        handleIpChange={handleChangeData}
      />
      <InputFields
        label="Duration in Hours"
        name="durationInHours"
        required={true}
        value={data['durationInHours']}
        textFieldType={'number'}
        width={2}
        handleIpChange={handleChangeData}
      />

      <Grid item xs={12} sm={12} md={4} sx={{ alignContent: 'flex-end' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <Checkbox
            checked={data['missingHours'] == 1 ? true : false}
            name="missingHours"
            onChange={e => handleChangeData('missingHours', e.target.checked)}
          />
          <Typography variant="subtitle2">Missing Hours(Tick Box if hours not recorded on Machine)</Typography>
        </div>
      </Grid>
      {data['missingHours'] ? (
        <InputFields
          label="Non Productive Hours"
          name="nonProductiveHours"
          required={true}
          value={data['nonProductiveHours']}
          textFieldType={'number'}
          width={4}
          handleIpChange={handleChangeData}
        />
      ) : (
        ''
      )}
      <InputFields
        label="Reason for Non Productive Hours?"
        helperText={'This must be preapproved with your manager'}
        name="reasonForNonProductiveHours"
        required={true}
        value={data['reasonForNonProductiveHours']}
        textFieldType={'number'}
        width={6}
        handleIpChange={handleChangeData}
        multiline={true}
      />

      <InputFields
        label="Additional Information"
        name="additionalInformation"
        required={false}
        value={data['additionalInformation']}
        textFieldType={'text'}
        multiline={true}
        width={6}
        handleIpChange={handleChangeData}
      />

      <Grid item xs={12} sm={12} md={6}>
        <DropzoneUpload label="File Upload" onFileSelect={handleFileChange('files')} multiple={true} />

        <Box
          sx={{
            display: 'flex',
            overflowX: 'auto',
            gap: 1,
            py: 1,
            px: 0.5,
            alignItems: 'center',
            minHeight: 60,
          }}>
          {isLoading ? (
            <Box sx={{ display: 'flex' }}>
              <CircularProgress size={22} />
              <Typography style={{ marginLeft: 8 }}>Fetching Docs ...</Typography>
            </Box>
          ) : files && files?.length > 0 ? (
            files.map((file, index) => (
              <Tooltip title={file.docName} key={index}>
                <div>
                  <Chip
                    label={file?.documentName?.length > 20 ? file.documentName.slice(0, 18) + '…' : file.documentName}
                    color="success"
                    sx={{ fontSize: '0.7rem', height: '24px', px: 1 }}
                    onDelete={() => handleDeleteFiles(file)}
                    onClick={() => viewFile(file)}
                  />
                </div>
              </Tooltip>
            ))
          ) : (
            <Typography>No files uploaded.</Typography>
          )}
        </Box>
      </Grid>
    </Grid>
  );
};

export default HfOtherForm;
